import { APP_SETTINGS } from '../config/appSettings'

/** Sample the underdamped mass/spring response; no animation library or layout loop. */
export function previewSpringFrames(initialScale: number): Keyframe[] {
  const settings = APP_SETTINGS.motion.linkPreview
  const frequency = Math.sqrt(settings.springStiffness / settings.springMass)
  const damping = settings.springDamping / (2 * Math.sqrt(settings.springStiffness * settings.springMass))
  const dampedFrequency = frequency * Math.sqrt(1 - damping * damping)
  return Array.from({ length: settings.springSamples + 1 }, (_, index) => {
    const offset = index / settings.springSamples
    const time = offset * settings.revealMs / 1000
    const response = 1 - Math.exp(-damping * frequency * time)
      * (Math.cos(dampedFrequency * time) + damping * frequency / dampedFrequency * Math.sin(dampedFrequency * time))
    const scale = index === settings.springSamples ? 1 : initialScale + (1 - initialScale) * response
    return { offset, transform: `scale(${scale})`, opacity: Math.min(1, offset * 3) }
  })
}
